import * as React from "react"
import { useRouteError } from "react-router-dom"

export const NovusErrorBoundary = () => {
  const error = useRouteError() as { status?: number } | undefined
  if (error?.status === 404) {
    return (
      <ErrorLayout
        title="Oops.. the page you are looking for can't be found."
        message="Please check the url and try again."
      />
    )
  }

  return (
    <ErrorLayout
      title="Oops.. something went wrong."
      message="Please try again."
    />
  )
}
const ErrorLayout = ({
  title,
  message,
}: {
  title: string
  message: string
}) => {
  return (
    <div>
      {title} - {message}
    </div>
  )
}
